module.exports = __webpack_public_path__ + "img/wallet_connect.84c155b4.svg";